import React, { FC, useCallback, useContext, useMemo } from 'react';
import cn from 'classnames';
import { Typography } from '../../Typography';
import { PaginationContext } from '../PaginationContext';
require("./PaginationItem.css");
var styles = {
  "Root": "PaginationItem-module-Root_eWX",
  "Inactive": "PaginationItem-module-Inactive_17z",
  "Active": "PaginationItem-module-Active_3wq",
  "Typography": "PaginationItem-module-Typography_3JU",
  "TypographyInactive": "PaginationItem-module-TypographyInactive_1w-",
  "TypographyActive": "PaginationItem-module-TypographyActive_3Mt"
};
export const PaginationItem = ({
  pageNumber
}) => {
  const {
    onClick,
    activePageNumber,
    typographyVariant,
    typographyWeight,
    fontSize
  } = useContext(PaginationContext);
  const handleClick = useCallback(() => {
    if (pageNumber !== activePageNumber) onClick(pageNumber);
  }, [pageNumber, activePageNumber, onClick]);
  const isActive = useMemo(() => pageNumber === activePageNumber, [pageNumber, activePageNumber]);
  return /*#__PURE__*/React.createElement("button", {
    "aria-label": `Страница-${pageNumber}`,
    className: cn(styles.Root, {
      [styles.Active]: isActive,
      [styles.Inactive]: !isActive
    }),
    onClick: handleClick
  }, /*#__PURE__*/React.createElement(Typography, {
    className: cn(styles.Typography, {
      [styles.TypographyActive]: isActive,
      [styles.TypographyInactive]: !isActive
    }),
    variant: typographyVariant,
    weight: typographyWeight,
    style: {
      fontSize
    }
  }, pageNumber));
};